import { render, staticRenderFns } from "./ManufacturedwithLandIcon.vue?vue&type=template&id=994f64a6&functional=true"
import script from "./ManufacturedwithLandIcon.vue?vue&type=script&lang=js"
export * from "./ManufacturedwithLandIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0d1d51ab4c56f75a7402f3cb98fb63e0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports